module.exports = __webpack_public_path__ + "img/layout_horizontal_crisscross.8cfd661c.svg";